import React from 'react';
import {
    Container
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaymentErrorIcon from '../../assets/images/paymentError.svg'
import Label from '../../components/Common/Label';

const PaymentError: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div className="pt-sm-5 pt-3 pb-4 d-flex align-items-center justify-content-center">
            <Container style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="payment-wrapper" style={{
                    border: '1px solid #D6D6D7',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    padding: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: '20px',
                    marginTop: '100px',
                    width: '550px',
                    minWidth: '200px',
                }}>
                    <div className="top-section d-flex align-items-center justify-content-center flex-column gap-2">
                        <img src={PaymentErrorIcon} alt="Payment Error Icon" />
                        <Label
                            children='Payment Failed'
                            color='#C00F0C'
                            fontWeight={700}
                            fontSize={'20px'}
                        />
                    </div>
                    <div className="bottom-section d-flex align-items-center justify-content-center flex-column gap-4">
                        <Label
                            children='We encountered an issue while processing your payment.'
                            color='#757575'
                            fontWeight={400}
                            fontSize={'16px'}
                            className='text-center'
                        />
                        <button style={{
                            border: 'none',
                            backgroundColor: "#C00F0C",
                            color: 'white',
                            padding: '13px 25px',
                            borderRadius: '5px'
                        }}
                            className='c-scale'
                            onClick={() => navigate('/subscriptions')}
                        >Retry Payment</button>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default PaymentError;